import { render, staticRenderFns } from "./StepNoOrTags.vue?vue&type=template&id=0987971b&scoped=true&"
import script from "./StepNoOrTags.vue?vue&type=script&lang=js&"
export * from "./StepNoOrTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0987971b",
  null
  
)

export default component.exports